export function formatPriceAmount(price) {
    return Number(price).toLocaleString("fr-CM", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).replace(/\s/g, "\u00a0");
}

export function formatPrice(price) {
    return `${formatPriceAmount(price)}\u00a0FCFA`;
}

export function formatLineTotal(unitPrice, quantity) {
    return formatPrice(Number(unitPrice) * Number(quantity));
}

export function formatStock(quantity) {
    return `${quantity} en stock`;
}

/** Review average: whole numbers without decimal (4), otherwise one decimal (4.3). */
export function formatRatingGrade(grade) {
    const value = Number(grade) || 0;
    const rounded = Math.round(value * 10) / 10;
    return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
}

export function formatRatingOutOfFive(grade) {
    return `${formatRatingGrade(grade)} / 5`;
}

export function formatPurchaseDate(isoDate) {
    if (!isoDate) {
        return "";
    }
    return new Date(isoDate).toLocaleDateString("fr-FR", {
        day: "numeric",
        month: "long",
        year: "numeric",
        timeZone: "Africa/Douala"
    });
}

export function productImageUrl(fileId, options = {}) {
    if (!fileId) {
        return null;
    }
    const base = `/api/v1/files/${fileId}`;
    if (options.size === "thumb") {
        return `${base}?size=thumb`;
    }
    return base;
}

export function formatProductStatus(status) {
    const labels = {
        CREATED: "Créé",
        READY: "Publié",
        DELETED: "Supprimé"
    };
    return labels[status] || status;
}

export function productStatusClassName(status) {
    const key = (status || "").toLowerCase();
    return key ? `product-status product-status--${key}` : "product-status";
}

export function formatLotStatus(status) {
    const labels = {
        CREATED: "Créé",
        READY: "Prêt",
        ARCHIVED: "Archivé",
        DELETED: "Supprimé"
    };
    return labels[status] || status;
}

export function lotStatusClassName(status) {
    const key = (status || "").toLowerCase();
    return key ? `lot-status lot-status--${key}` : "lot-status";
}

export function formatAdvertisementStatus(status) {
    const labels = {
        PUBLISHED: "Publiée",
        PENDING_APPROVAL: "En attente d'approbation",
        HIDDEN: "Masquée",
        DELETED: "Supprimée"
    };
    return labels[status] || status || "—";
}

export function advertisementStatusClassName(status) {
    const key = (status || "").toLowerCase();
    return key ? `advertisement-status advertisement-status--${key}` : "advertisement-status";
}

export function formatFulfillmentType(type) {
    if (type === "DELIVERY") {
        return "Livraison à l'adresse";
    }
    return "Retrait en magasin";
}

export const ORDER_STATUSES = {
    PENDING: "PENDING",
    CONFIRMED: "CONFIRMED",
    PREPARING: "PREPARING",
    READY: "READY",
    COMPLETED: "COMPLETED",
    CANCELLED: "CANCELLED"
};

export const ORDER_STATUS_OPTIONS = [
    { value: ORDER_STATUSES.PENDING, label: "En attente" },
    { value: ORDER_STATUSES.CONFIRMED, label: "Confirmée" },
    { value: ORDER_STATUSES.PREPARING, label: "En préparation" },
    { value: ORDER_STATUSES.READY, label: "Prête" },
    { value: ORDER_STATUSES.COMPLETED, label: "Terminée" },
    { value: ORDER_STATUSES.CANCELLED, label: "Annulée" }
];

export function formatOrderStatus(status) {
    const labels = {
        [ORDER_STATUSES.PENDING]: "En attente",
        [ORDER_STATUSES.CONFIRMED]: "Confirmée",
        [ORDER_STATUSES.PREPARING]: "En préparation",
        [ORDER_STATUSES.READY]: "Prête",
        [ORDER_STATUSES.COMPLETED]: "Terminée",
        [ORDER_STATUSES.CANCELLED]: "Annulée"
    };
    return labels[status] || status || "";
}

export function orderStatusClassName(status) {
    const key = (status || "").toLowerCase();
    return key ? `order-status order-status--${key}` : "order-status";
}

/** Customer may cancel or edit only while the order is still pending. */
export function canCustomerModifyOrder(status) {
    return status === ORDER_STATUSES.PENDING;
}

/** PDF receipt download for customers when the order is completed and the feature flag allows it. */
export function canDownloadOrderReceipt(order, { customerDownloadEnabled = true } = {}) {
    return order?.status === ORDER_STATUSES.COMPLETED
        && !!order?.receiptNumber
        && customerDownloadEnabled !== false;
}
